export const polish = {
  feedback: {
    "title": "Wyślij opinię",
    "category": "Kategoria",
    "suggestion": "Sugestia",
    "problem": "Problem",
    "other": "Inne",
    "message": "Twoja opinia",
    "placeholder": "Co chcesz poprawić lub co nie działało?",
    "email": "Email do odpowiedzi (opcjonalnie)",
    "send": "Wyślij opinię",
    "sending": "Wysyłanie…",
    "success": "Dziękujemy — otrzymaliśmy Twoją opinię.",
    "error": "Nie udało się wysłać opinii. Tekst został zachowany; spróbuj ponownie.",
    "invalid": "Wpisz od 10 do 3000 znaków i poprawny email, jeśli go podajesz.",
    "signIn": "Zaloguj się, aby wysłać opinię",
    "inbox": "Opinie użytkowników",
    "empty": "Brak opinii.",
    "reviewed": "Przeczytane",
    "markReviewed": "Oznacz jako przeczytane",
    "refresh": "Odśwież",
    "new": "Nowe"
},
  menu: {
    signOut: "Wyloguj",
    signIn: "Zaloguj / Zarejestruj",
    talkToUs: "Porozmawiaj z nami",
    language: "Język",
    deleteAccount: "Usuń Konto",
    accountSettings: "Ustawienia konta",
  },
  theme: {
    light: "Jasny",
    dark: "Ciemny",
  },
  landing: {
    heroKicker: "Dla obywateli i gmin na całym świecie",
    heroSub: "Przekazujemy Twój głos gminie — w dowolnym miejscu na świecie.",
    municipalityLogin: "Logowanie gminy",
    pecCardTitle: "Każde zgłoszenie dociera do gmin na całym świecie",
    pecBadge: "E-mail",
    pecCardBody: "Z każdego miasta, w każdym kraju. Partnerskie gminy otrzymują zgłoszenia bezpośrednio; gdzie gmina nie jest jeszcze partnerem, nadal wysyłamy każde zgłoszenie do lokalnych władz pocztą e-mail, aby żaden problem nie pozostał niewidoczny.",
    pecTitle: "Każde zgłoszenie ma znaczenie, nawet bez partnerstwa",
    pecBody: "Jeśli Twoja gmina nie jest jeszcze partnerem ShapeIt, nadal wysyłamy każde zgłoszenie do lokalnych władz pocztą e-mail, aby żaden problem nie pozostał niewidoczny.",
    pecHighlight: "Przesyłamy zgłoszenia do gmin pocztą e-mail",
    ctaSub: "Dołącz do obywateli i gmin na całym świecie i zmieniaj rzeczywistość, jedno zgłoszenie na raz.",
  },
  mapHeader: {
    appName: "Shapeit",
    login: "Zaloguj / Zarejestruj",
    searchPlaceholder: "Wyszukaj miejsce lub kliknij w dowolnym miejscu mapy, aby zgłosić problem",
    clearSearch: "Wyczyść wyszukiwanie",
  },
  mapLegend: {
    title: "Legenda Shapeit",
    buttonLabel: "Legenda",
    dirty: "Brudny",
    unsafe: "Niebezpieczny",
    needsFix: "Do Naprawy",
  },
  dialog: {
    selectLanguage: "Wybierz preferowany język",
    chooseLanguage: "Wybierz język interfejsu aplikacji.",
    confirm: "Potwierdź",
    welcome: {
      title: "Witaj!",
      message: "Shapeit jest tutaj, aby Cię wzmocnić. Chcemy, abyś mógł kształtować swoje miasto i przekształcać je w lepsze miejsce. Za każdym razem, gdy zauważysz problem, możesz go zgłosić, a także polubić zgłoszenia innych użytkowników, aby nadać im większą widoczność. Z naszej strony dopilnujemy, aby władze miasta były na bieżąco informowane o najpilniejszych problemach.",
      message2: "Shapeit pracuje nad nawiązaniem współpracy z gminami na całym świecie. Nawet jeśli Twoje miasto nie jest jeszcze naszym partnerem, wysyłamy każde zgłoszenie do lokalnych władz pocztą e-mail, aby żaden problem nie pozostał niewidoczny. Każde zgłoszenie pomaga budować aktualną bazę danych problemów miejskich w Twojej okolicy: im więcej zgłoszeń zbierzemy, tym silniejszy będzie nasz głos, gdy zwrócimy się do lokalnych władz. A teraz idź i uczyń swoje miasto lepszym miejscem!",
      next: "Dalej",
      button: "Zaczynajmy!"
    }
  },
  reports: {
    overview: "Przegląd Zgłoszeń",
    trending: "Popularne",
    myReports: "Moje Zgłoszenia",
    yourReports: "Twoje Zgłoszenia",
    recentReports: "Ostatnie Zgłoszenia",
    by: "przez",
    anonymous: "Anonimowy",
  },
  usernameSetup: {
    title: "Wybierz swoją nazwę użytkownika",
    description: "Wybierz publiczną nazwę widoczną przy Twoich zgłoszeniach. Możesz ją zmienić w ustawieniach konta.",
    placeholder: "Twoja nazwa użytkownika",
    save: "Zapisz",
    saving: "Zapisywanie...",
    skip: "Później",
    tooShort: "Nazwa użytkownika musi mieć co najmniej 2 znaki",
    noEmail: "Nazwa użytkownika nie może zawierać @",
    success: "Nazwa użytkownika zapisana",
    error: "Nie udało się zapisać nazwy użytkownika",
  },
  reportForm: {
    postAnonymously: "Opublikuj anonimowo",
    postAnonymouslyHint: "Twoja nazwa nie będzie widoczna przy tym zgłoszeniu.",
    postingAs: "Publikujesz jako",
    title: "Zgłoś Problem",
    description: "Opis",
    uploadPhoto: "Dodaj Zdjęcie",
    takePhoto: "Zrób Zdjęcie",
    changePhoto: "Zmień Zdjęcie",
    preview: "Podgląd",
    submit: "Wyślij Zgłoszenie",
    submitting: "Wysyłanie...",
    loginRequired: "Musisz się zalogować, aby zgłosić problem",
    uploadFailed: "Nie udało się przesłać zgłoszenia",
    photoUploadFailed: "Nie udało się wysłać zdjęcia. Twoje zgłoszenie jest nadal tutaj.",
    sendWithoutPhoto: "Wyślij bez zdjęcia",
    selectIssue: "Wybierz typ problemu",
    selectIssueType: "Wybierz typ problemu",
    moderationWarning: "Zgłoszenia są automatycznie moderowane. Obraźliwe, spamowe lub nieodpowiednie treści zostaną odrzucone.",
    rejectedContent: "Twoje zgłoszenie zawiera nieodpowiednie treści i nie może zostać opublikowane",
    rateLimitExceeded: "Osiągnąłeś limit 5 zgłoszeń na godzinę. Spróbuj ponownie później.",
    characterLimit: "Opis nie może przekraczać 500 znaków",
    appealLink: "Prześlij odwołanie przez e-mail",
    offensiveContent: "Twoja wiadomość zawiera nieodpowiedni język",
    validatingImage: "Weryfikacja obrazu...",
        aiAnalyzing: "AI analizuje...",
    duplicateWarning: "Podobne zgłoszenie już istnieje w pobliżu. Rozważ głosowanie zamiast tworzenia duplikatu.",
    aiSuggestions: "Sugestie AI",
    suggestedTitle: "Sugerowany tytuł:",
    priority: "Priorytet:",
    inappropriateImage: "Obraz zawiera nieodpowiednie treści i nie może być użyty",
    notRelevantImage: "Zdjęcie nie wydaje się przedstawiać problemu miejskiego. Prześlij zdjęcie problemu, który chcesz zgłosić.",
  },
  confirmReport: {
    question: "Czy chcesz utworzyć zgłoszenie tutaj?",
    yes: "Tak",
    no: "Nie"
  },
  locationPrompt: "Kliknij w wybrane miejsce, aby zgłosić problem",
  reportHere: "Zgłoś tutaj",
  deleteAccount: {
    title: "Usuń Konto",
    warning: "Ta czynność jest nieodwracalna!",
    description: "Wszystkie Twoje dane zostaną trwale usunięte, w tym:",
    items: {
      reports: "Wszystkie Twoje zgłoszenia",
      photos: "Wszystkie przesłane zdjęcia",
      accountData: "Informacje o Twoim koncie"
    },
    confirmLabel: "Wpisz DELETE, aby potwierdzić",
    confirmPlaceholder: "DELETE",
    cancel: "Anuluj",
    deleteButton: "Usuń Moje Konto",
    deleting: "Usuwanie...",
    success: "Konto zostało pomyślnie usunięte",
    error: "Nie udało się usunąć konta"
  },
  gamification: {
    totalReports: "Łączna liczba zgłoszeń",
    congratulations: "Gratulacje!",
    pointsEarned: "Zdobyte punkty",
    totalPoints: "Suma punktów",
    currentLevel: "Aktualny poziom",
    levelUp: "Awans!",
    nextLevel: "Następny poziom",
    progress: "Postęp",
    thankYou: "Dziękujemy za uczynienie miasta lepszym miejscem!",
    keepGoing: "Kontynuuj zgłaszanie, aby osiągnąć kolejny poziom!",
    continue: "Kontynuuj",
    levels: {
      beginner: "Początkujący",
      active_citizen: "Aktywny obywatel",
      urban_observer: "Obserwator miejski",
      city_guardian: "Strażnik miasta",
      civic_champion: "Mistrz obywatelski",
      urban_hero: "Bohater miejski"
    },
    messages: {
      beginner: "Witaj w społeczności!",
      active_citizen: "Robisz różnicę!",
      urban_observer: "Twoje oczy czynią miasto lepszym!",
      city_guardian: "Jesteś prawdziwym strażnikiem!",
      civic_champion: "Mistrz obowiązku obywatelskiego!",
      urban_hero: "Jesteś bohaterem miejskim!"
    }
  },
  onboarding: {
    step1: {
      title: "Witaj na Mapie!",
      description: "Tutaj możesz zobaczyć wszystkie zgłoszenia z Twojej społeczności. Nauczmy się, jak z niej korzystać!"
    },
    step2: {
      title: "Utwórz Zgłoszenie",
      description: "Wyszukaj lokalizację lub kliknij na mapę, aby utworzyć nowe zgłoszenie dotyczące problemu w Twojej okolicy."
    },
    step3: {
      title: "Typy Zgłoszeń",
      description: "Różne kolory reprezentują różne typy problemów. Kliknij na znaczniki, aby zobaczyć szczegóły i głosuj na zgłoszenia, które Cię obchodzą!"
    },
    step4: {
      title: "Twój Profil i Gamifikacja",
      description: "Zdobywaj punkty, tworząc zgłoszenia i pomagając swojej społeczności! Śledź swój poziom i postępy tutaj."
    },
    step5: {
      title: "Jesteś Gotowy!",
      description: "Zacznij ulepszać swoją społeczność, zgłaszając problemy i angażując się w inne zgłoszenia. Każdy wkład się liczy!"
    },
    previous: "Poprzedni",
    next: "Dalej"
  },
    accountSettings: {
    title: "Ustawienia konta",
    openSettings: "Ustawienia konta",
    changeEmail: "Zmień email",
    newEmailLabel: "Nowy adres email",
    newEmailPlaceholder: "nowy@email.com",
    changePassword: "Zmień hasło",
    newPasswordLabel: "Nowe hasło",
    newPasswordPlaceholder: "Co najmniej 6 znaków",
    passwordTooShort: "Hasło musi mieć co najmniej 6 znaków",
    passwordSuccess: "Hasło zostało zaktualizowane",
    changeUsername: "Zmień nazwę użytkownika",
    newUsernameLabel: "Nowa nazwa użytkownika",
    newUsernamePlaceholder: "Twoja nazwa użytkownika",
    usernameTooShort: "Nazwa użytkownika musi mieć co najmniej 2 znaki",
    usernameSuccess: "Nazwa użytkownika została zaktualizowana",
    deleteAccountTitle: "Usuń konto",
    deleteAccountDescription: "Trwale usuń swoje konto i wszystkie powiązane dane. Tej czynności nie można cofnąć.",
    deleteAccountButton: "Usuń konto",
    save: "Zapisz",
    saving: "Zapisywanie...",
    submit: "Wyślij email potwierdzający",
    submitting: "Wysyłanie...",
    invalidEmail: "Nieprawidłowy adres email",
    error: "Błąd",
    updateFailed: "Nie można zaktualizować",
    successTitle: "Wysłano email weryfikacyjny",
    successDescription: "Wysłaliśmy email potwierdzający na adres {email}. Sprawdź swoją skrzynkę, aby potwierdzić zmianę.",
    showPassword: "Pokaż hasło",
    hidePassword: "Ukryj hasło",
  },
  push: {
    title: "Powiadomienia push",
    subtitle: "Zarządzaj powiadomieniami na swoim urządzeniu",
    enable: "Włącz powiadomienia push",
    denied: "Odmowa uprawnień. Włącz powiadomienia w ustawieniach urządzenia.",
    registered: "Urządzenie zarejestrowane",
    requestPermission: "Poproś o zgodę na powiadomienia",
    resolved: "Zgłoszenie rozwiązane",
    resolvedDesc: "Gdy jedno z Twoich zgłoszeń zostanie rozwiązane",
    upvotes: "Otrzymane głosy",
    upvotesDesc: "Gdy ktoś zagłosuje na Twoje zgłoszenie",
    achievements: "Odblokowane osiągnięcia",
    achievementsDesc: "Gdy odblokujesz nowe osiągnięcie",
    newReports: "Nowe zgłoszenia",
    newReportsDesc: "Gdy powstają nowe zgłoszenia",
    updated: "Preferencje zaktualizowane",
    updateError: "Nie udało się zaktualizować preferencji",
    mobileOnly: "Powiadomienia push są dostarczane w aplikacji mobilnej",
  },
  referral: {
    inviteTitle: "Zaproś znajomych i zdobywaj punkty!",
    inviteSubtitle: "Utwórz swój kod zaproszenia i zdobywaj 50 punktów za każdego znajomego.",
    createCode: "Utwórz kod zaproszenia",
    yourCode: "Twój kod zaproszenia",
    copy: "Kopiuj",
    codeCopied: "Kod skopiowany do schowka!",
    linkCopied: "Link zaproszenia skopiowany!",
    directLink: "Link bezpośredni",
    stats: "Statystyki zaproszeń",
    completed: "Zakończone",
    pending: "Oczekujące",
    total: "Razem",
    ambassadorProgress: "Postęp Ambasadora",
    ambassadorUnlocked: "Odblokowano odznakę Ambasadora!",
    shareText: "Dołącz do ShapeIt i pomóż ulepszyć swoje miasto! Użyj kodu {code}, aby otrzymać 50 punktów bonusowych 🎁",
    shareTitle: "Zaproszenie ShapeIt",
  },
  misc: {
    mapLoadFailed: "Nie udało się załadować mapy",
    mapKeyError: "Nie udało się pobrać klucza API Google Maps",
    mapKeyMissing: "Klucz API Google Maps nie jest skonfigurowany",
    mapsLoadError: "Nie udało się załadować Google Maps",
    onlyImages: "Dozwolone są tylko obrazy JPEG, PNG i WebP",
    imageTooLarge: "Obraz musi być mniejszy niż 5MB",
    photoFailed: "Nie udało się zrobić zdjęcia",
    current: "Aktualny",
    progress: "Postęp",
  },
  common: {
    share: "Udostępnij",
    shareTitle: "Udostępnij to zgłoszenie",
    copyLink: "Kopiuj link",
    linkCopied: "Link skopiowany do schowka!",
    copyFailed: "Nie udało się skopiować linku",
    loading: "Ładowanie...",
    close: "Zamknij",
    delete: "Usuń",
    cancel: "Anuluj",
    retry: "Spróbuj ponownie",
    login: "Zaloguj",
    register: "Zarejestruj",
    email: "Email",
    password: "Hasło",
    username: "Nazwa użytkownika",
    anonymous: "Anonimowy",
    notYourReport: "To nie Twoje zgłoszenie",
    loginToDelete: "Zaloguj się, aby usunąć",
    upvotes: "Głosy",
    reportedBy: "Zgłoszone przez",
    trending: "Popularne",
    trendingReports: "Popularne zgłoszenia",
    noTrending: "Brak popularnych zgłoszeń",
    yourReports: "Twoje zgłoszenia",
    noReportsYet: "Nie utworzyłeś jeszcze żadnych zgłoszeń",
    loadingAddress: "Ładowanie adresu…",
    myLocation: "Moja lokalizacja",
    yourLocation: "Twoja lokalizacja",
    mapView: "Widok mapy",
    satelliteView: "Widok satelitarny",
    changePhoto: "Zmień zdjęcie",
    uploadingPhoto: "Przesyłanie...",
    photoUpdated: "Zdjęcie profilowe zaktualizowane",
    photoUploadError: "Nie udało się przesłać zdjęcia",
    removePhoto: "Usuń zdjęcie",
    inviteFriends: "Zaproś znajomych",
    achievements: "Osiągnięcia",
    noAchievements: "Brak odblokowanych osiągnięć",
    statusHistory: "Historia statusu",
    seeTranslation: "Pokaż tłumaczenie",
    seeOriginal: "Pokaż oryginał",
    translating: "Tłumaczenie...",
    translationFailed: "Tłumaczenie niedostępne",
    translatedAutomatically: "Przetłumaczone automatycznie",
    deleteConfirm: "Czy chcesz usunąć to zgłoszenie?",
    loginToDeleteReports: "Zaloguj się, aby usuwać zgłoszenia",
    onlyOwnReports: "Możesz usuwać tylko własne zgłoszenia",
  },
  auth: {
    backToMap: "Powrót do mapy",
    subtitle: "Zaloguj się lub załóż konto, aby zgłaszać problemy w swojej okolicy",
    login: "Zaloguj",
    register: "Zarejestruj",
    email: "Email",
    password: "Hasło",
    username: "Nazwa użytkownika",
    orContinueWith: "Lub kontynuuj przez",
    signInGoogle: "Zaloguj się przez Google",
    signUpGoogle: "Zarejestruj się przez Google",
    signingIn: "Logowanie...",
    signIn: "Zaloguj się",
    referralLabel: "Kod zaproszenia (opcjonalnie) 🎁",
    referralPlaceholder: "Wpisz kod zaproszenia",
    referralBonus: "Z tym kodem otrzymasz 50 punktów bonusowych! 🎁",
    creatingAccount: "Tworzenie konta...",
    createAccount: "Utwórz konto",
    showPassword: "Pokaż hasło",
    hidePassword: "Ukryj hasło",
  },
  analytics: {
    otherCategory: "Inne",
    pageTitle: "Panel analityczny",
    pageSubtitle: "Publiczne statystyki i przejrzystość zgłoszeń społeczności",
    backToMap: "Powrót do mapy",
    noData: "Brak dostępnych danych",
    communityTitle: "Analityka społeczności",
    communitySubtitle: "Statystyki zgłoszeń obywatelskich w czasie rzeczywistym",
    municipalityScopedSubtitle: "Statystyki zgłoszeń z Twojej gminy w czasie rzeczywistym",
    totalReports: "Łączna liczba zgłoszeń",
    inProgress: "W toku",
    resolved: "Rozwiązane",
    avgTime: "Średni czas",
    categoryTitle: "Podział według kategorii",
    categoryDesc: "Rodzaje otrzymanych zgłoszeń",
    trendTitle: "Trend z ostatnich 7 dni",
    trendDesc: "Liczba dziennych zgłoszeń",
    topAreasTitle: "Najczęściej zgłaszane obszary",
    topAreasDesc: "Obszary z największą liczbą aktywnych zgłoszeń",
    adminTitle: "Zaawansowana analityka (Admin)",
    adminSubtitle: "Szczegółowe wskaźniki widoczne tylko dla administratorów",
    dau: "Dzienni aktywni użytkownicy",
    wau: "Tygodniowi aktywni użytkownicy",
    mau: "Miesięczni aktywni użytkownicy",
    avgSession: "Średni czas sesji",
    minutesShort: "min",
    mapInteractions: "Interakcje z mapą",
    perSession: "Średnio na sesję",
    reportsPerUser: "Zgłoszenia na użytkownika",
    average: "Średnia",
    completionRate: "Wskaźnik ukończenia",
    loginToReport: "Logowanie → Zgłoszenie",
    funnelTitle: "Lejek konwersji",
    funnelDesc: "Analiza ścieżki użytkownika (ostatnie 7 dni)",
    users: "Użytkownicy",
    conversionPct: "% Konwersji",
    devicesTitle: "Rozkład urządzeń",
    devicesDesc: "Analiza używanych urządzeń",
  },
};
